import { render, staticRenderFns } from "./Add_org_modal.vue?vue&type=template&id=ac2948dc"
import script from "./Add_org_modal.vue?vue&type=script&lang=js"
export * from "./Add_org_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports